<template>
  <div>
    <div class="container-fluid pt-0 row mx-0 bg-primary">
      <article
        class="
          container-fluid
          card
          col-sm-12 col-md-12 col-lg-10 col-xl-10
          mycard-scale
          my-4
        "
      >
        <page-breadcrumb :items="page.crumbs" />
        <h1 class="h3 my-3">{{ page.h1 }}</h1>
        <p class="p2em">
          这个地址没有对应页面。你可以回到桂运宝首页，或查看大宗货运业务方案和常见问题。
        </p>
        <ul>
          <li><router-link to="/">返回桂运宝首页</router-link></li>
          <li><router-link to="/solutions">查看大宗货物运输业务方案</router-link></li>
          <li><router-link to="/faq">查看常见问题</router-link></li>
          <li>
            <a href="tel:07722991568">咨询电话 0772-2991568</a>
          </li>
        </ul>
      </article>
    </div>
  </div>
</template>

<script>
import { PAGES } from "@/seo/site";

/**
 * 未知路径使用的 404 页。
 */
export default {
  name: "NotFound",
  computed: {
    page: function () {
      return PAGES.notFound;
    },
  },
};
</script>
